import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ contentHeight: number }>()(
  (theme: Theme, { contentHeight }) => ({
    root: {
      '& .MuiTypography-root.MuiDialogTitle-root': {
        height: 'auto',
        justifyContent: 'end',
        border: 'none',
      },

      '& .MuiPaper-root.MuiDialog-paperFullScreen': {
        borderRadius: theme.spacing(0),

        '& .MuiDialogTitle-root': {
          display: 'flex',
          flexDirection: 'column-reverse',
          justifyContent: 'space-around',
          width: '100%',

          '& div': {
            alignSelf: 'flex-start',
            backgroundColor: theme.palette.modal.paper,
          },
          '& button': {
            alignSelf: 'flex-end',
          },
        },
      },

      '& .MuiDialogContent-root': {
        padding: theme.spacing(0),
        height: theme.spacing(contentHeight / 8),
      },

      '& .MuiPaper-root': {
        backgroundColor: theme.palette.modal.paper,
        borderRadius: theme.spacing(2.5),
      },

      '& .MuiDialogTitle-root': {
        padding: theme.spacing(2, 2.375, 2, 3.125),
      },

      '& .MuiDialogActions-root': {
        padding: theme.spacing(1.5, 2),
        display: 'flex',
        flexDirection: 'column',

        '& .MuiButtonBase-root.MuiButton-root': {
          zIndex: 2,
        },

        '&>:not(:first-of-type)': {
          marginTop: theme.spacing(1.875),
          marginLeft: theme.spacing(0),
        },
      },
    },

    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: `${theme.spacing(0.125)} solid #1b1c1f`,
      height: theme.spacing(6.5),
      backgroundColor: theme.palette.modal.paper,
    },

    title: {
      flex: 1,
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
      fontFamily: 'Noto Sans',

      '&.MuiTypography-root': {
        fontSize: theme.spacing(1.75),
      },
    },

    closeIcon: {
      display: 'flex',
      alignSelf: 'baseline',
      justifyContent: 'end',
      width: theme.spacing(3.125),
      height: theme.spacing(3.125),
      zIndex: 5,

      '&.MuiIconButton-root': {
        marginLeft: theme.spacing(1),
        justifyContent: 'center',
      },
    },

    body: {
      padding: theme.spacing(1, 4),
      backgroundColor: theme.palette.modal.paper,
    },

    actions: {
      backgroundColor: theme.palette.modal.paper,
    },

    titleContainer: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      width: '100%',
    },

    actionButton: {
      width: '100%',
    },
  })
);
